import { BaseModel } from '../../_base/crud';

export class AgreementTemplate extends BaseModel {
  id: number;
  created: string;
  company_id: string;
  name: string;
  description: string;
  offices: number[];
  type: string;
  status: string;
  file_base64: string;
  active: boolean;
  url: string;

  clear() {
    this.id = 0;
    this.created = '';
    this.company_id = '';
    this.file_base64 = '';
    this.name = '';
    this.description = '';
    this.offices = [];
    this.type = '';
    this.status = '';
    this.active = false;
    this.url = '';
  }
}
